import styled, { css } from 'styled-components/macro';
import {CircularProgressColorByCurrentApp, MuiFormLabelFilledColorByCurrentApp, SvgIconFillColorByCurrentApp, SvgIconFillColorOpenByCurrentApp, UserIconBoxShadowByCurrentApp, UserIconBoxShadowHoverByCurrentApp, SvgIconWidthByCurrentApp} from '../../utils/get-app-env';

import {
  Box,
  Card,
  CircularProgress,
  Container,
  Grid, Menu, TextField
} from '@material-ui/core';

import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider
} from '@material-ui/pickers';

const getSizeProperty = (props: any) =>
  props.container
    ? `
    width: 100%; 
    height: 100vh;
  `
    : `
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
  `;


const IframeSize = css`
  width: 480px;
  height: 380px;
`;

export const StyledContainer = styled(Container)`
  && {
    padding: 0;
    margin: 0;
    @media (width: 1920px) {
      max-width: 120rem;
    }
  }
`;

export const StyledGrid = styled(Grid)`
  ${(props) => getSizeProperty(props)}
`;

export const StyledCard = styled(Card)`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  height: 100%;
  min-width: 250px;
`;

export const StyledForm = styled.form`
  width: 100%;
  height: 60vh;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
`;

export const StyledTextField = styled(TextField)`
  width: 90%;
`;

export const StyledDatePicker = styled(KeyboardDatePicker)`
  width: 90%;
  & .MuiInputBase-input {
    color: ${(MuiFormLabelFilledColorByCurrentApp())};
  }
`;

export const StyledPickersContainer = styled(MuiPickersUtilsProvider)``;

export const iframeGridStyle = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  padding: '7%',
};

export const StyledCircularProgress = styled(CircularProgress)`
  color: ${(CircularProgressColorByCurrentApp())};
  backgroundColor: ${(CircularProgressColorByCurrentApp())};
  margin: 100px 0px;
  ${IframeSize}
`;

export const StyledBox = styled(Box)`
  display: flex;
  justify-content: center;
  text-align: center;
  margin: 50px 0px;
`;

export const StyledHeaderContent = styled.div`
  height: 200px;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;

  h6 {
    padding: 0 20px;
  }
`;

export const GloboIcon = styled.img`
  width: ${SvgIconWidthByCurrentApp()};
  align-self: flex-start;
  margin-left: 15px;
  max-height: 130px;
  margin-top: 30px;

`;

export const StyledSVG = styled.svg<{ color: string; }>`
  width: 30px;
  position: relative;
  fill: ${props => props.color};
`;

export const UserIconWrapper = styled.div<{ onClick: any, isMenuOpen: boolean }>`
  position: absolute;
  top: 10px;
  right: 25px;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  display: grid;
  place-items: center;
  box-shadow: ${UserIconBoxShadowByCurrentApp()};
  cursor: pointer;
  
  transition: all .5s ease;

  svg {
    width: 40px;
    height: 40px;
    fill: ${props => props.isMenuOpen ? SvgIconFillColorOpenByCurrentApp() : SvgIconFillColorByCurrentApp()};
  }

  :hover {
    box-shadow: ${UserIconBoxShadowHoverByCurrentApp()};

    svg {
      transition: all .5s ease;
      fill: ${SvgIconFillColorByCurrentApp()};
    }
  }
`;

export const IframeContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  position: relative;
`;

export const StyledMenu = styled(Menu)`
  section {
    text-align: center;
    padding: 8px 0;
  }

  li:hover {
    background-color: rgb(34 59 107 / 7%);

    button {
      color: #f45248;
    }
  }
`;

export const MenuExitButton = styled.button`
  width: 100%;
  border: none;
  background-color: transparent;
  text-align: left;
  cursor: pointer;
  font: inherit;
  color: inherit;
`;